import React from "react";
import { Form } from "rsuite";

const ContactDetails = () => {
  return (
    <div className="grid grid-cols-1 mt-3 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
      <Form.Group>
        <Form.ControlLabel>Mobile No.</Form.ControlLabel>
        <Form.Control name="Mobile No." type="number" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Phone No.</Form.ControlLabel>
        <Form.Control name="Phone No." type="number" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Email</Form.ControlLabel>
        <Form.Control name="Email" type="email" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Foreign Phone no.</Form.ControlLabel>
        <Form.Control name="ForeignPhoneno." type="number" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Foreign Address</Form.ControlLabel>
        <Form.Control name="Foreign Address" />
      </Form.Group>
    </div>
  );
};

export default ContactDetails;
